module.exports = __webpack_public_path__ + "static/media/fa-brands-400.4291d4b6.eot";